import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllDonations } from "../../services/DonationService";
import { DonationFilter } from "../../types/donation.types";

interface DonationState {
    donationList: any[];
    loading: boolean;
    error: string | null;
    filters: DonationFilter;
}

const initialState: DonationState = {
    donationList: [],
    loading: false,
    error: null,
    filters: {}
};

export const donationSlice = createSlice({
    name: "donation",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        setFilters: (state, action: PayloadAction<Partial<DonationFilter>>) => {
            state.filters = {
                ...state.filters,
                ...action.payload
            };
        },
        clearFilters: (state) => {
            state.filters = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDonations.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllDonations.fulfilled, (state, action) => {
                state.loading = false;
                state.donationList = action.payload;
            })
            .addCase(getAllDonations.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch donations";
            });
    }
});

export const {
    clearError,
    setFilters,
    clearFilters
} = donationSlice.actions;

export default donationSlice.reducer;
